jQuery(function ($) {

    $(document).ready(function () {
        initFancyList();
    });

    $(window).bind("load", function () {
        detectBranchID();
        detectOrderType();
        detectTopics();
    });

    function initFancyList() {
        var $list = $('.fancy-list .fl-rich-text > ul > li');

        $list.click(function () {
            var $elm = $(this);
            var $subnav = $elm.find('> ul');

            if ($subnav[0]) {
                $subnav.slideToggle();
                $elm.toggleClass('active');
            }
        });
    }

    function detectBranchID() {
        var branchIDs = { lansing: 155, pomfret: 125, annapolis: 187, newark: 194, boston: 195, philadelphia: 45, hme: 131, stlouis: 161, baltimore: 149, southbend: 197, cincinnati: 203, desmoines: 127, lasvegas: 88, buffalo: 57, charlotte: 107, indianapolis: 139, toledo: 189 };
        var pagePath = window.location.pathname.split('/');
        var branchLocation = pagePath[1];

        if (branchLocation != "") {
            $form = $('#nf-form-2-cont');

            if ($form) {
                var locationKey = branchLocation.replace("-", "");
                var keyValue = branchIDs[locationKey];
                $('input[name=nf-field-15]').val(keyValue).trigger('change');
                //console.log($('input[name=nf-field-15]').val());
            }
            else {
                return;
            }
        } else {
            return;
        }

    }

    function detectOrderType() {
        var orderTypes = { ramps: 'Access - Ramp', inhomelifts: 'Access - Patient Lift', vehiclelifts: 'Access - Vehicle Lift', stairlifts: 'Access - Stair Lift' };
        var pagePath = window.location.pathname.split('/');
        var orderType = pagePath[2];

        if (orderType != "") {
            $form = $('#nf-form-2-cont');

            if ($form) {
                if (orderType != "") {
                    var typeKey = orderType.replace("-", "");
                    var keyValue = orderTypes[typeKey];
                    $('input[name=nf-field-16]').val(keyValue).trigger('change');
                } else {
                    $('input[name=nf-field-16]').val('Access - Misc').trigger('change');
                }
            }
            else {
                return;
            }
        } else {
            return;
        }
    }

    function detectTopics() {
        var pagePath = window.location.pathname.split('/');
        var branchLocation = pagePath[1];
        
        // Make sure our path is one we need to do stuff with and that the form exists
        if ( locationTopicKeys[ branchLocation ] ) {
            // Vars
            var location = locationTopicKeys[ branchLocation ];
            var topicKey = location.topicKey;
            var subtopicKey = location.subtopicKey;
            var formProps = formKeys[ location.formKey ];

            // Elements
            $formElement = $( formKeys[ location.formKey ].formID );
            $topicKeyField = $( formProps.topicFieldID );
            $subtopicKeyField = $( formProps.subtopicFieldID );

            // Make sure our form exists
            if ( $formElement[0] ) {
                $topicKeyField.val( topicKey ).trigger( 'change' );
                $subtopicKeyField.val( subtopicKey ).trigger( 'change' );
            }
        }
    }

    // Storage for detectTopics function
    var formKeys = {
        "6": {
            "formID": "#nf-form-6-cont",
            "topicFieldID": "#nf-field-63",
            "subtopicFieldID": "#nf-field-64",
        },
        "3": {
            "formID": "#nf-form-3-cont",
            "topicFieldID": "#nf-field-65",
            "subtopicFieldID": "#nf-field-66",
        },
        "4": {
            "formID": "#nf-form-4-cont",
            "topicFieldID": "#nf-field-67",
            "subtopicFieldID": "#nf-field-68",
        }
    }
    var locationTopicKeys = {
        "atlanta": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "67f5bf37-9691-eb11-b1ac-00224809bf84"
        },
        "las-vegas": {
          "formKey": "3",
          "topicKey": "214f5928-602e-eb11-a813-00224808125f",
          "subtopicKey": "34bde649-9691-eb11-b1ac-00224809bf84"
        },
        "milwaukee": {
          "formKey": "3",
          "topicKey": "214f5928-602e-eb11-a813-00224808125f",
          "subtopicKey": "53a588a7-8491-eb11-b1ac-00224809bf84"
        },
        "access-checklist": {
          "formKey": "3",
          "topicKey": "214f5928-602e-eb11-a813-00224808125f",
          "subtopicKey": "ec224b83-8191-eb11-b1ac-00224809bf84"
        },
        "buffalo-mynsm": {
            "formKey": "6",
            "topicKey": "7bfeb3ab-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "79ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "charlotte-mynsm": {
            "formKey": "6",
            "topicKey": "7bfeb3ab-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "7bea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "chicago": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "65ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "chicagoland-mynsm": {
            "formKey": "6",
            "topicKey": "7bfeb3ab-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "7dea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "delaware-valley-mynsm": {
            "formKey": "6",
            "topicKey": "7bfeb3ab-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "7fea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "delaware-valley": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "67ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "annapolis": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "5dea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "dmv-mynsm": {
            "formKey": "6",
            "topicKey": "7bfeb3ab-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "73ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "midwest-mynsm": {
            "formKey": "6",
            "topicKey": "7bfeb3ab-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "77ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "midwest": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "6bea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "new-england": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "5fea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "new-england-mynsm": {
            "formKey": "6",
            "topicKey": "7bfeb3ab-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "75ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "new-york-mynsm": {
            "formKey": "6",
            "topicKey": "7bfeb3ab-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "81ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "new-york-region": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "61ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "north-carolina": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "63ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "new-york": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "69ea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "texas": {
            "formKey": "3",
            "topicKey": "214f5928-602e-eb11-a813-00224808125f",
            "subtopicKey": "6dea8c3f-702e-eb11-a813-000d3a5a7f74"
        },
        "referral-form": {
            "formKey": "4",
            "topicKey": "80a8dfbd-6d2e-eb11-a813-00224808125f",
            "subtopicKey": "93ea8c3f-702e-eb11-a813-000d3a5a7f74"
        }
    };
});